<script setup>
import { ChevronDown } from 'lucide-vue-next';

const model = defineModel({ type: [String, Number], default: '' });
defineProps({
  id: { type: String, default: null },
  /** Array of strings or { value, label } */
  options: { type: Array, default: () => [] },
  placeholder: { type: String, default: '' },
  invalid: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  /** md or sm */
  size: { type: String, default: 'md' },
});
const val = (o) => (typeof o === 'object' ? o.value : o);
const lab = (o) => (typeof o === 'object' ? o.label : o);
</script>

<template>
  <div class="pd-select" :class="[`pd-select--${size}`, { 'is-invalid': invalid }]">
    <select :id="id" v-model="model" :disabled="disabled" :aria-invalid="invalid || undefined">
      <option v-if="placeholder" value="" disabled>{{ placeholder }}</option>
      <option v-for="o in options" :key="val(o)" :value="val(o)">{{ lab(o) }}</option>
    </select>
    <ChevronDown class="pd-select__chev" :size="18" :stroke-width="2.25" aria-hidden="true" />
  </div>
</template>

<style scoped>
.pd-select { position: relative; }
.pd-select select {
  appearance: none;
  width: 100%;
  height: 52px;
  padding: 0 44px 0 16px;
  border: 1px solid var(--pd-line);
  border-radius: var(--pd-r-sm);
  background: var(--pd-white);
  font-weight: 700;
  cursor: pointer;
  outline: none;
}
.pd-select--sm select { height: 40px; font-size: 0.875rem; }
.pd-select select:focus { border-color: var(--pd-line-active); box-shadow: var(--pd-ring); }
.pd-select select:disabled { background: var(--pd-cream); cursor: not-allowed; }
.pd-select.is-invalid select { border-color: var(--pd-danger); }
.pd-select__chev { position: absolute; right: 14px; top: 50%; transform: translateY(-50%); pointer-events: none; }
</style>
